"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetweenPartsPlacement = void 0;
var BetweenPartsPlacement;
(function (BetweenPartsPlacement) {
    BetweenPartsPlacement["PlacementBetweenParts"] = "between_parts";
    BetweenPartsPlacement["PlacementBetweenPartsFirst"] = "between_parts_first";
    BetweenPartsPlacement["PlacementBetweenPartsLast"] = "between_parts_last";
})(BetweenPartsPlacement = exports.BetweenPartsPlacement || (exports.BetweenPartsPlacement = {}));
